import { parseExtensionId } from '@atlassian/forge-ui/utils/parseExtensionId';
export var normalizeExtensions = function normalizeExtensions(forgeExtensions) {
  return forgeExtensions.reduce(function (accumulator, current) {
    var _parseExtensionId = parseExtensionId(current.id),
      appId = _parseExtensionId.appId,
      envId = _parseExtensionId.environmentId;
    var combinedAppEnvId = "".concat(appId, "/").concat(envId);

    // by this condition we make sure the first IA module is rendered (appEnvId key is not overwritten)
    // and integration code is deterministic (if you add a new IA module,
    // the 1st one will be rendered, not the last one)
    if (!accumulator[combinedAppEnvId]) {
      accumulator[combinedAppEnvId] = current;
    }
    return accumulator;
  }, {});
};